import type { ColumnProvider } from '../../interfaces/ColumnProvider';

export default function calculateColumnIndexFromPoint(
    x: number,
    parentBounds: { left: number; width: number },
    columnProvider: ColumnProvider,
    isRTL: boolean
): number {
    let xPosition = isRTL ? parentBounds.width - x + parentBounds.left : x - parentBounds.left;
    let xPercentage = xPosition / parentBounds.width;

    if (xPosition < 0) {
        return -1;
    } else if (xPosition > parentBounds.width) {
        return columnProvider.columnLayouts.length;
    }

    let colIndex = -1;
    columnProvider.columnLayouts.forEach((layout, index) => {
        if (layout.left <= xPercentage && 1 - layout.right >= xPercentage) {
            colIndex = index;
        }
    });

    return colIndex;
}
